var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluencerSentiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "influencerSentiment",
    transform: "translate(-1.75 -1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11533",
    "data-name": "Path 11533",
    d: "M2.27,9.75H9.75V2.27c-.167-.013-.355-.02-.536-.02A6.963,6.963,0,0,0,2.25,9.214C2.25,9.4,2.257,9.583,2.27,9.75Z",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11534",
    "data-name": "Path 11534",
    d: "M6.056,15.846a6.964,6.964,0,1,0,5.967-11.3v7.48H4.542A6.943,6.943,0,0,0,6.056,15.846Z",
    transform: "translate(-1.201 -1.201)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencerSentiment);
export default __webpack_public_path__ + "static/media/influencerSentiment.6e0dbb636802f8d1a35653acf313ea54.svg";
export { ForwardRef as ReactComponent };